import {AfterViewInit, inject, Injectable} from '@angular/core';
import {AppSettingsStore} from "../../store/app-settings.store";

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  readonly appSettingsStore = inject(AppSettingsStore);

  constructor() {
    this.toggleDarkTheme(this.appSettingsStore.darkTheme())
  }

  toggleDarkTheme(darkTheme: boolean | undefined) {
    if (darkTheme === undefined) {
      darkTheme = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    this.appSettingsStore.setDarkTheme(darkTheme);
    if (darkTheme) {
      document.body.classList.remove('light-theme');
    } else {
      document.body.classList.add('light-theme');
    }
    this.setThemeColor();
  }

  setThemeColor(color?: string) {
    color = color || getComputedStyle(document.body).getPropertyValue('--mat-app-background-color');
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', color);
  }
}
